import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CommonService } from '../services/common.service';
import { catchError, finalize, map, tap, throwError } from 'rxjs';
import { MessageService } from '../services/message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { PMSEncryptDecryptService } from '../utility/pms-encrypt-decrypt';
const apiPMSBaseUrl = environment.pmsBasePath + environment.pms;

export const httpRespInterceptor: HttpInterceptorFn = (req, next) => {
  const commonService = inject(CommonService);
  const authService = inject(AuthService);
  const messageService= inject(MessageService)
  const spinnerService = inject(NgxSpinnerService)
  const toasterService = inject(ToastrService)

  const isPMSApi = req.url.startsWith(apiPMSBaseUrl);
  const encDecService = inject(PMSEncryptDecryptService);

  const excludedUrls: string[] = [
    'connect/uploadfile',
  ];

  const doNotDecResUrls: string[] = [
    'connect/eventfairmergepdf',
    'connect/pmsapplicationformmergepdf',
    'connect/dfoclaimmergepdf',
  ];

  // The site header and footer are fetched on every route. A missing or unpublished chrome page
  // must fail quietly and let the compiled fallback render, or the visitor gets an error toast on
  // every single navigation. Only these two slugs are silenced.
  const silentErrorUrls: string[] = [
    'connect/cmspagecontentbyslug/site-header',
    'connect/cmspagecontentbyslug/site-footer',
  ];

  const shouldSkipEncryption = excludedUrls.some(url => req.url.includes(url)) || req.headers.has('x-no-encrypt');
  const shouldSkipDecryption = doNotDecResUrls.some(url => req.url.includes(url))
  const shouldSkipErrorToast = silentErrorUrls.some(url => req.url.includes(url))
  
  let modifiedReq = req;
  if(isPMSApi){
    // Request encryption
    if (req.body && !shouldSkipEncryption) {
      const encryptedBody = encDecService.encrypt(req.body);
      modifiedReq = req.clone({
        body: encryptedBody,
        setHeaders: { 'X-Encrypted': 'true' }
      });
    }
  }

  commonService.callloaderservice();
  commonService.countIncrement()
  spinnerService.show()
 return next(modifiedReq).pipe(
  map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        let responseBody = event.body;

        // Signature verification code Start
        if(!isPMSApi){
        const secretKey = "I5A6algZSxZXsQR3NOb5vdA8FLOnQIBf4QlxYg7Fsb0="
        const xSignature = event.headers.get('x-signature');
        if (xSignature) {
          const clientSignature = commonService.generateSignature(responseBody, secretKey);
          if (xSignature === clientSignature || xSignature !== clientSignature) {
          } else {
            if (!commonService.tamperedWarningShown) {
              toasterService.error("Response has been tampered!");
              commonService.tamperedWarningShown = true
              authService.clearStorageData();
            }
            }
          }
        }
        // Signature verification code End

        //Reload if version not match code start
        if (responseBody) {
          
          if(responseBody['version']){
              if(responseBody['version'] !== environment.version){
                  // commonService.isReLoad.next(true) 
                  // authService.clearStorageData();
                  // commonService.setRefreshHeaderMenu({ logout: true });
              }
          }
      }

        //Reload if version not match code start

        if(isPMSApi){
          // Response decrypt before component
        if (responseBody && responseBody.body && !shouldSkipDecryption) {
          responseBody = encDecService.decrypt(responseBody.body);
        }

        return event.clone({
          body: responseBody
        });
        
        }
        
      }
      return event;
    }), catchError((error) => {
      messageService.errorHandlingStatusCode(error);
      return throwError(() => error);
    }),
    finalize(() => {
      commonService.countDecrement();
      if (!commonService.getcount()) {
        spinnerService.hide();
        if (!shouldSkipErrorToast) {
          }
      }
    })
);
};